import * as Yup from "yup";
import React from "react";
import { FormItemProps } from "@/components/Form/types";




const getItems = (fileNames: string[]): FormItemProps[] => {
    return [

    {
        name: 'name',
        label: 'Name',
        placeholder: 'Enter File name',
        type: 'Text',
        defaultValue: null,
        validation: Yup.string()
            .required('Name is required')
            .notOneOf(fileNames, 'This name is not allowed'),
        classNames: {container: 'col-span-6 '},
        autoFocus: true,
    },
    {
        name: 'jsx',
        label: 'JSX',
        placeholder: 'Enter jsx code',
        type: 'Code',
        defaultValue: null,
        classNames: {container: 'col-span-12 break-line'},
        itemOptions: {
            script: 'javascript',
        }
    },
    {
        name: 'note',
        label: 'Note',
        placeholder: 'Enter note for this element',
        type: 'Code',
        defaultValue: null,
        classNames: {container: 'col-span-12 break-line'},
        itemOptions: {
            script: 'markdown',
        }
    },
    {
        name: 'css',
        label: 'CSS',
        placeholder: 'Enter css code',
        type: 'Code',
        defaultValue: null,
        classNames: {container: 'col-span-12 break-line'},
        itemOptions: {
            script: 'css',
        }
    },
    {
        name: 'mobileCss',
        label: 'Mobile Css',
        placeholder: 'Enter css code of mobile view',
        type: 'Code',
        defaultValue: null,
        classNames: {container: 'col-span-12 break-line'},
        itemOptions: {
            script: 'css',
        }
    },
    {
        name: 'tabletCss',
        label: 'Tablet Css',
        placeholder: 'Enter css code of tabled view',
        type: 'Code',
        defaultValue: null,
        classNames: {container: 'col-span-12 break-line'},
        itemOptions: {
            script: 'css',
        }
    },

    {
        name: 'start_group',
        label: 'Styles',
        placeholder: 'style fields',
        type: 'Group',
        itemOptions: {
            groupList: ['tabletCss','mobileCss', 'css'],
            toggle: true,
        },
        classNames: {container: 'col-span-12 break-line'},

    }


]}

export default getItems;